import React from "react";
import { cn } from "../../lib/cn";

export interface NavItemProps {
  label: string;
  icon?: React.ReactNode;
  active?: boolean;
  onClick?: () => void;
  href?: string;
  className?: string;
}

/** claudesign sidebar nav row. Mirrors `.nav-item` / `.nav-item.active`
 *  from docs/redesign/ommuse-theme.css. */
export const NavItem: React.FC<NavItemProps> = ({
  label,
  icon,
  active,
  onClick,
  href,
  className,
}) => {
  const classes = cn(
    "flex items-center gap-[14px] px-[14px] py-[11px] rounded-sm cursor-pointer",
    "text-[15px] font-medium no-underline",
    "transition-[background,color] duration-150",
    "[&_svg]:w-[21px] [&_svg]:h-[21px] [&_svg]:shrink-0",
    active
      ? "text-white bg-[linear-gradient(90deg,rgba(39,182,203,.16),rgba(39,182,203,.03))] shadow-[inset_2px_0_0_var(--cyan),var(--edge-hi)]"
      : "text-muted hover:text-body hover:bg-[rgba(255,255,255,.03)]",
    className,
  );
  const content = (
    <>
      {icon}
      <span className="min-w-0 truncate">{label}</span>
    </>
  );
  return href ? (
    <a
      href={href}
      aria-current={active ? "page" : undefined}
      onClick={onClick}
      className={classes}
    >
      {content}
    </a>
  ) : (
    <button
      type="button"
      aria-current={active ? "page" : undefined}
      onClick={onClick}
      className={classes}
    >
      {content}
    </button>
  );
};

export default NavItem;
